import mongoose from "mongoose";

export interface WhatsNewFeature {
  _id: string;
  featureTitle: string;
  featureDescription: string;
  isInternal: boolean;
}

export interface WhatsNew {
  _id: mongoose.Schema.Types.ObjectId;
  releaseDate: string;
  releaseTitle: string;
  features: WhatsNewFeature[];
}

export const WhatsNewSchema = new mongoose.Schema<WhatsNew>({
  releaseDate: { type: String, required: true },
  releaseTitle: { type: String, required: true },
  features: [{
    featureTitle: { type: String, required: true },
    featureDescription: { type: String, required: true },
    isInternal: { type: Boolean, required: true },
  }],
});
